import { makeStyles } from '@material-ui/core'
import type { DataNode } from 'components/WorkspaceEditor/types'
import { useProjectSettings } from 'components/WorkspaceEditor/Workspace2Store'
import {
    TableEditorProps,
    TableElement,
} from 'pages/ProjectsPage/WorkspacePage/components/Common/TableEditor'
import React, { memo } from 'react'
import { withLazyLoad } from '../withLazyComponent'

const TableEditor = withLazyLoad<TableEditorProps>(() =>
    import('pages/ProjectsPage/WorkspacePage/components/Common/TableEditor').then(
        (module) => ({ default: module.TableEditor })
    )
)

// Tables can be wider than the workspace column, so scroll horizontally instead of wrapping.
const useStyles = makeStyles(() => ({
    tableScrollContainer: {
        overflowX: 'auto',
        maxWidth: '100%',
    },
}))

export interface TableContentProps {
    node: DataNode
}

/** Renders an imported table read-only, reusing Classic Workspace's TableEditor. */
export const TableContent = memo<TableContentProps>(({ node }) => {
    const { tableScrollContainer } = useStyles()
    const projectSettings = useProjectSettings()

    if (!node.tableData?.elements) return null

    return (
        <div className={tableScrollContainer}>
            <TableEditor
                element={node.tableData as unknown as TableElement}
                isEditable={false}
                projectSettings={projectSettings}
            />
        </div>
    )
})
